import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './Components/HomePage/Navbar';
import Hero from './Components/HomePage/Hero';
import HowItWorks from './Components/HomePage/HowItWorks';
import ClinicalValue from './Components/HomePage/ClinicalValue';
import Differentiators from './Components/HomePage/Differentiators';
import InvestmentShowcase from './Components/HomePage/InvestmentShowcase';
import PressSection from './Components/HomePage/PressSection';
import FinalCTA from './Components/HomePage/FinalCTA';
import Footer from './Components/HomePage/Footer';
import SignUpPage from './Components/SignUpPage/SignUpPage';
import LoginPage from './Components/LoginPage/LoginPage';
import Dashboard from './Components/Dashboard/Dashboard';
import FertilityCareDashboard from './Components/DashboardFertilityCare/Dashboard';
import ForgotPassword from './Components/LoginPage/ForgotPassword';
import FollowUpDashboard from './Components/DashboardFollowUp/Dashboard';
import usePageTracking from './PageTracking';
import SuccessPage from './pages/checkout/CheckoutSuccess';
import FailedPage from './pages/checkout/CheckoutFailed';
import ManageSubscriptionPage from './pages/subscriptions/ManageSubscriptionPage';
import MonitoringDashboard from './Components/MonitoringDashboard/MonitoringDashboard';
import MonitoringDashboardLogin from './Components/MonitoringDashboard/MonitoringDashboardLogin';
import AthletesDashboard from './Components/DashboardAthletes/AthletesDashboard';
import PrescriptionDashboard from './Components/PrescriptionDashboard/PrescriptionDashboard';
import ProtectedRoute from './Components/MonitoringDashboard/ProtectedRoute';
import CareersPage from './Components/HomePage/CareersPage';
import JobDetailsPage from './Components/HomePage/JobDetailsPage';
import ContactSalesPage from './Components/HomePage/ContactSalesPage';
import ApiKeyDashboard from './Components/ApiKeyDashboard/ApiKeyDashboard';
import AdminApiDashboard from './Components/AdminApiDashboard/AdminApiDashboard';
import { Navigate } from 'react-router-dom';

// Landing page kept intentionally light. Sections available but not mounted
// (re-import from ./Components/HomePage and drop back into the tree to re-enable):
//   Audience              — Audience.jsx        ("Who this is for")
//   TechnicalCapabilities — TechnicalCapabilities.jsx ("Built for hospitals")
//   FAQ                   — FAQSection.jsx
const HomePage = () => {
  return (
    <div className="bf-page">
      <Navbar />
      <Hero />
      <ClinicalValue />
      <HowItWorks />
      <Differentiators />
      <InvestmentShowcase />
      <PressSection />
      <FinalCTA />
      <Footer />
    </div>
  );
};

function AppRoutes() {
  usePageTracking();
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />}/>
      <Route path="/fertility-care-dashboard" element={<FertilityCareDashboard />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/follow-up-form-fertilitycare" element={<FollowUpDashboard />} />
      <Route path="/checkout/success" element={<SuccessPage />} />
      <Route path="/checkout/failed" element={<FailedPage />} />
      <Route path="/dashboard/subscription" element={<ManageSubscriptionPage />} />
      <Route path="/admin/monitoring-dashboard" element={<MonitoringDashboardLogin />} />
      <Route path="/athlete-dashboard" element={<AthletesDashboard />} />
      <Route path="/prescription-dashboard" element={<PrescriptionDashboard />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/careers/:id" element={<JobDetailsPage />} />
      <Route path="/contact-sales" element={<ContactSalesPage />} />
      <Route path="/client-api-dashboard" element={<ApiKeyDashboard />} />
      <Route path="/team-api-dashboard" element={<AdminApiDashboard />} />
      
      <Route 
          path="/admin/monitoring-dashboard/view" 
          element={
            <ProtectedRoute>
              <MonitoringDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Catch-all redirect to login */}
        <Route path="/admin/*" element={<Navigate to="/admin/monitoring-dashboard" replace />} />
        

    </Routes>
  );
}

export default AppRoutes;
